export default __webpack_public_path__ + "static/media/popAd7.a2dd6d7b.gif";